import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal } from '../../../state-actions/hideModal';
import ModalStyled, {
  ModalBg,
  ModalButton,
  ModalText,
  ModalTitle,
} from './Modal.styled';

const mapDispatchToProps = dispatch => ({
  hideModal: bool => dispatch(hideModal(bool)),
});

export const Modal = ({ title, content, btnText, hideModal }) => (
  <ModalBg>
    <ModalStyled>
      <ModalTitle>{title}</ModalTitle>
      <ModalText>{content}</ModalText>
      <ModalButton onClick={() => hideModal(true)}>{btnText}</ModalButton>
    </ModalStyled>
  </ModalBg>
);

export default connect(
  null,
  mapDispatchToProps
)(Modal);

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  btnText: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/molecules/Modal/Modal.js